"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUNDLE_CARD = exports.CREATE_A_BUNDLE = exports.MC_SIDEGRADE_MODAL = exports.MIGRATE_YOUR_SITE = exports.CMS_CARD = exports.SUITE_CALCULATOR = exports.SUITE_CARD = exports.CALCULATOR = exports.EXTENDED_MERCH_CARD = exports.MERCH_CARD = exports.SUBSCREENS = exports.SCREENS = exports.APP = void 0;
var APP = 'pricing-pages';
exports.APP = APP;
var SCREENS = {
  PRODUCTS_PLANS: 'products-plans',
  CREATE_BUNDLE: 'create-bundle',
  GROWTH_SUITE: 'growth-suite',
  ERROR: 'error',
  CONTACT_CONFIRMATION: 'contact-confirmation',
  SUITE_CONTACT_CONFIRMATION: 'suite-contact-confirmation',
  MC_CONTACT_CONFIRMATION: 'mc-contact-confirmation',
  CONTACT_SALES: 'contact-sales',
  LEGACY_INTERSTITIAL: 'legacy-interstitial'
};
exports.SCREENS = SCREENS;
var SUBSCREENS = {
  MARKETING_HUB: 'marketing-hub',
  SALES_HUB: 'sales-hub',
  SERVICE_HUB: 'service-hub',
  CMS: 'cms',
  CMS_HUB: 'cms-hub',
  FREE_TOOLS_CRM: 'free-tools-crm'
};
exports.SUBSCREENS = SUBSCREENS;
var MERCH_CARD = 'merch-card';
exports.MERCH_CARD = MERCH_CARD;
var EXTENDED_MERCH_CARD = 'extended-merch-card';
exports.EXTENDED_MERCH_CARD = EXTENDED_MERCH_CARD;
var CALCULATOR = 'calculator';
exports.CALCULATOR = CALCULATOR;
var SUITE_CARD = 'suite-card';
exports.SUITE_CARD = SUITE_CARD;
var SUITE_CALCULATOR = 'suite-calculator';
exports.SUITE_CALCULATOR = SUITE_CALCULATOR;
var CMS_CARD = 'cms-card';
exports.CMS_CARD = CMS_CARD;
var MIGRATE_YOUR_SITE = 'migrate-your-site';
exports.MIGRATE_YOUR_SITE = MIGRATE_YOUR_SITE;
var MC_SIDEGRADE_MODAL = 'mc-sidegrade-modal';
exports.MC_SIDEGRADE_MODAL = MC_SIDEGRADE_MODAL;
var CREATE_A_BUNDLE = 'create-a-bundle';
exports.CREATE_A_BUNDLE = CREATE_A_BUNDLE;
var BUNDLE_CARD = 'bundle-card';
exports.BUNDLE_CARD = BUNDLE_CARD;